import React, { useState, useEffect } from 'react';

import cls from 'classnames';
import Spreader from '../../Spreader';

import InViewMonitor from 'react-inview-monitor';

import './styles.css';

import Slider from 'react-slick';

import Map from './Map';
import YaMap from './YaMap';
import SmartMap from './SmartMap';

import useWindowSize from '../../utils/useWindowSize';

import { InView } from 'react-intersection-observer';

export default props => {
  const size = useWindowSize();

  const height = Math.min(700, size.width * 0.65);

  const settings = {
    arrows: true,
    dots: false,
    appendDots: false,
    lazyLoad: false,
    infinite: true,
    speed: 50,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 8000,
  };

  return (
    <div className={cls('MapSlider', props.className)}>
      <InView>
        {({ inView, ref, entry }) => (
          <div ref={ref}>
            <Spreader>
              <Map isVisible={inView} />
            </Spreader>
          </div>
        )}
      </InView>
    </div>
  );
};

/* 
                <Slider {...settings}>
                  <Map />
                  
                  <SmartMap />
                  <YaMap height={height} />
                  
                </Slider>
                */
